import React from 'react';
import {Box, Container, Link, Typography} from '@material-ui/core';
import {RouteComponent} from '../RouteComponent';
import DocumentationScreen from '../documentation/DocumentationScreen';


export default new RouteComponent('/', () => {

    return (
        <Container>
            <Box mt={ 10 }>
                <Typography align="center">
                    <img src="fblogo.png" alt="Fishbowl Logo" style={ { paddingBottom: '2%', paddingTop: '2%', maxWidth: '300px' } }/>
                    <Typography variant="h3" style={{ color: '#4caf50', fontWeight: 'bold', marginBottom: '20px' }}>
                        Fishbowl Advanced Server is Running
                    </Typography>
                    <Typography variant="h6" style={{ color: '#666' }}>
                        The server is successfully operational and ready to handle requests.
                    </Typography>
                </Typography>
            </Box>
            <Box mt={ 10 } textAlign="center">
                <Link href={ DocumentationScreen.path } target="_blank" style={{ fontSize: '1.1rem' }}>
                    REST Documentation
                </Link>
            </Box>
        </Container>
    );
});
